export default __webpack_public_path__ + "static/media/trafficOff.67961aac.png";